export default __webpack_public_path__ + "static/media/start-class.55fef65b.svg";